import { create } from 'zustand'

type ToggleSubMenuArgs = {
  expanded?: boolean
  tutorial?: string | null
}

interface SubMenuState {
  expanded: boolean
  tutorial: string | null
  toggleSubMenu: (args: ToggleSubMenuArgs) => void
}

const useSubMenuStore = create<SubMenuState>(set => ({
  expanded: true,
  tutorial: null,
  toggleSubMenu: ({ expanded, tutorial }) =>
    set(state => ({
      expanded: expanded ?? state.expanded,
      tutorial,
    })),
}))

export default useSubMenuStore
